/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'react',
	'react-dom',
	'prop-types',
	'@ba/ba-ui-carbon-toolkit'
], function(
	React,
	ReactDOM,
	PropTypes,
	UI_Toolkit
) {

	const { Component } = React;
	const { ContextMenu } = UI_Toolkit;

	class ContextMenuWrapper extends Component {

		render () {
			const { theme, placement = 'bottomRight', align = 'left', domNodeToAttachTo = document.body, triggerNode, contextMenuItems, onClose, onChange } = this.props;

			if (!contextMenuItems || !contextMenuItems.length) {
				return;
			}

			return (
				<ContextMenu
					theme={theme}
					placement={placement}
					align={align}
					triggerNode={triggerNode}
					domNodeToAttachTo={domNodeToAttachTo}
					onClose={onClose}
					onChange={onChange}
				>
					{this._renderMenuItems(contextMenuItems)}
				</ContextMenu>
			);
		}

		_renderMenuItems(items) {
			if (items) {
				return items.map((section, index) => this._renderMenuSection(section, index));
			}
		}

		_renderMenuSection(section, key) {
			if (Array.isArray(section.items)) {
				const { name = 'menu', label, items } = section;

				return <ContextMenu.List
					key={key}
					content={items}
					name={name}
					label={label}
					clickSelection={true} />;
			} else {
				return <ContextMenu.Separator
					key={key}
				/>;
			}
		}
	}

	ContextMenuWrapper.propTypes = {
		contextMenuItems: PropTypes.array,
		placement: PropTypes.string,
		align: PropTypes.string,
		triggerNode: PropTypes.object,
		style: PropTypes.object,
		domNodeToAttachTo: PropTypes.object,
		theme: PropTypes.bool,
		onClose: PropTypes.func,
		onChange: PropTypes.func
	};

	return ContextMenuWrapper;
});
